package com.crowpay.views.dialogs

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.utils.navigateTo
import com.crowpay.views.theming.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.dialog
import com.lightningkite.kiteui.views.direct.*


class GenericConfirmationDialog(
    val header: String?,
    val message: String,
    val question: String? = null,
    val confirmationText: String,
    val declineText: String = "Go Back",
    val confirmationTheme: ThemeDerivation = PrimaryButtonSemantic,
    val allowDismiss: Boolean = true,
    val dismissOnConfirm: Boolean = true,
    val dismiss: ViewWriter.()->Unit = { dialogScreenNavigator.dismiss() },
    val onSubmit: suspend (Boolean) -> Unit,
) : Page {
    override fun ViewWriter.render2(): ViewModifiable {

        suspend fun submit(value: Boolean) {
            onSubmit(value)
            if (!value || dismissOnConfirm) dismiss()
        }
        return dismissBackground {
            spacing = AppDimensions.fullIndent
            dialog - centered - stack {
                spacing = AppDimensions.fullIndent
                col {
                    themeChoice = ThemeDerivation { appTheme.withoutBack }
                    spacing = theme.spacing * 1.5

                    if (header != null) title(header)

                    col {
                        if (message.isNotBlank()) sizeConstraints(maxWidth = 40.rem, minWidth = 10.rem) - body(message)

                        if (question != null) sizeConstraints(maxWidth = 40.rem, minWidth = 10.rem) - body(question)
                    }

                    row {
                        spacing = AppDimensions.buttonRowSpacing

                        confirmationTheme.onNext - button {
                            specCenteredText(confirmationText)
                            onClick {
                                submit(true)
                            }
                        }

                        textButton - button {
                            specCenteredText(declineText)
                            onClick {
                                submit(false)
                            }
                        }
                    }
                }
            }
            onClick {
                if (allowDismiss) {
                    onSubmit(false)
                }
            }
        }
    }
}

fun ViewWriter.confirmationDialog(
    header: String,
    message: String,
    confirmationText: String,
    declineText: String = "Go Back",
    confirmationTheme: ThemeDerivation = PrimaryButtonSemantic,
    allowDismiss: Boolean = true,
    onConfirm: suspend () -> Unit
) {
    dialogScreenNavigator navigateTo GenericConfirmationDialog(
        header,
        message,
        confirmationText = confirmationText,
        declineText = declineText,
        confirmationTheme = confirmationTheme,
        allowDismiss = allowDismiss
    ) {
        if (it) onConfirm()
    }
}